import config from '../../config'

import { getDelegateAccessMine } from '../../entities/delegateAccess/service'

import { logErrorMessage } from '../../utils/logger'

import queryClient from '../../queryClient'
import {
  TIME_ENTRIES_QUERY_KEY,
  PROJECTS_QUERY_KEY,
  ASSIGNMENTS_QUERY_KEY,
  TIMESHEETS_QUERY_KEY,
  TIME_OFF_ENTRIES_QUERY_KEY,
  TIME_OFF_CODES_QUERY_KEY,
  OUTLOOK_EVENTS_QUERY_KEY,
  OUTLOOK_EMAILS_QUERY_KEY,
  USER_SETTINGS_QUERY_KEY,
  DELEGATE_ACCESS_QUERY_KEY,
} from '../../hooks/queries/keys'

const { IS_DELEGATE_ENABLED } = config

export const syncTimesheets = async () => {
  await queryClient.invalidateQueries({ queryKey: TIMESHEETS_QUERY_KEY })
  return true
}

export const syncTimeEntries = async () => {
  await queryClient.invalidateQueries({ queryKey: TIME_ENTRIES_QUERY_KEY })
  return true
}

export const syncTimeOffEntries = async () => {
  await queryClient.invalidateQueries({ queryKey: TIME_OFF_ENTRIES_QUERY_KEY })
  return true
}

export const syncProjects = async () => {
  await queryClient.invalidateQueries({ queryKey: PROJECTS_QUERY_KEY })
  return true
}

export const syncTimeOffCodes = async () => {
  await queryClient.invalidateQueries({ queryKey: TIME_OFF_CODES_QUERY_KEY })
  return true
}

export const syncDelegateAccess = async ({ handleAppState, client, shouldRefresh }) => {
  if (!IS_DELEGATE_ENABLED) return
  try {
    const delegateAccesses = await getDelegateAccessMine({
      client,
      shouldRefresh,
    })
    queryClient.setQueryData(DELEGATE_ACCESS_QUERY_KEY, delegateAccesses ?? [])
    handleAppState({ delegateAccesses })
    return delegateAccesses
  } catch (error) {
    logErrorMessage(error)
  }
}

export const syncUserSettings = async () => {
  await queryClient.invalidateQueries({ queryKey: USER_SETTINGS_QUERY_KEY })
}

export const syncOutlookEvents = async () => {
  await queryClient.invalidateQueries({ queryKey: OUTLOOK_EVENTS_QUERY_KEY })
}

export const syncOutlookEmails = async () => {
  await queryClient.invalidateQueries({ queryKey: OUTLOOK_EMAILS_QUERY_KEY })
}

export const syncAssignments = async () => {
  await queryClient.invalidateQueries({ queryKey: ASSIGNMENTS_QUERY_KEY })
}
